import React, { Component } from 'react';
import Link, { withPrefix } from 'gatsby-link';
import './SideNav.css';

const SideNav = ({ location }) => {

        const isDocs = location === withPrefix("/docs");
        const isSkills = location === withPrefix("/docs/skills");
        const isSpells = location === withPrefix("/docs/spells");
        const isPowers = location === withPrefix("/docs/powers");
        return (
            <div className="container top-nav">
                <ul className="nav nav-tabs">
                    <li role="presentation" className={isDocs ? "active" : ""}><Link exact to="/docs">Policies</Link></li>
                    <li role="presentation" className={isSkills ? "active" : ""}><Link to="/docs/skills">Skills</Link></li>
                    <li role="presentation" className={isSpells ? "active" : ""}><Link to="/docs/spells">Spells</Link></li>
                    <li role="presentation" className={isPowers ? "active" : ""}><Link to="/docs/powers">Powers</Link></li>
                </ul>
            </div>
        );
}

export default SideNav;


// WEBPACK FOOTER //
// ./src/components/SideNav/SideNav.js